<template lang="pug">
div
  input(
    ref="uploader"
    style='display: none',
    :accept="customAccept || acceptFiles"
    @change="selectFile"
    name="file_name"
    type="file"
    v-bind="$attrs"
  )
  .pointer(@click="openChooseFile")
    //- v-progress-linear(
    //-   v-if="progress"
    //-   :value="progress"
    //-   color="primary"
    //-   height="6"
    //-   indeterminate
    //- )
    slot(name="activator" :disabled="disabled")
      v-btn(color="primary")
        | Выберите файл
        v-icon mdi-attachment

</template>

<script>
/* eslint-disable no-await-in-loop */
/* eslint-disable no-loop-func */
import { apiService } from '@/services/APIService';

export default {
  name: 'FileUpload',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'Файл',
    },
    label: {
      type: String,
      default: '',
    },
    customAccept: {
      type: String,
      default: '',
    },
    accept: {
      type: String,
      default: '',
      validator(val) {
        return ['', 'all', 'image', 'docsAndTable', 'table'].indexOf(val) !== -1;
      },
    },
  },
  data: () => ({
    file: '',
    original_name: '',
    progress: 0,
  }),
  computed: {
    acceptFiles() {
      switch (this.accept) {
        case 'all':
          return `
            .csv,
            .pps,
            .ppt,
            .pptx,
            image/*,
            application/pdf,
            application/msword,
            application/vnd.ms-excel,
            application/vnd.ms-powerpoint,
            application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
            application/vnd.openxmlformats-officedocument.presentationml.slideshow,
            application/vnd.openxmlformats-officedocument.wordprocessingml.document,
            application/vnd.openxmlformats-officedocument.presentationml.presentation,
          `;
        case 'image':
          return 'image/*';
        case 'table':
          return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        default:
          return 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      }
    },
  },
  methods: {
    openChooseFile() {
      if (!this.disabled) {
        this.$refs.uploader.click();
      }
    },
    async selectFile() {
      const file = this.$refs.uploader.files[0];
      if (!file) {
        this.file = '';
        return;
      }
      this.file = file;

      await this.uploadFile();
    },
    /**
     * Загружает файл на сервер, возвращает имя файла
     * @returns {Promise<unknown>}
     */
    uploadFile() {
      return new Promise((resolve) => {
        if (!this.file) {
          resolve(null);
          return;
        }

        const CHUNK_SIZE = 500 * 1024;
        const fileSize = this.file.size;
        this.original_name = this.file.name;

        // ADD Single upload
        this.uploadChunked(resolve, CHUNK_SIZE, fileSize);
      });
    },
    async uploadChunked(resolve, chunkSize, fileSize) {
      this.progress = 0;

      const dispositionName = Math.random().toString(32);
      const chunksCount = Math.ceil(fileSize / chunkSize);
      let response;
      for (let start = 0; start < fileSize; start += chunkSize) {
        const data = new FormData();
        data.append('file', this.file.slice(start, start + chunkSize), dispositionName);

        const request = apiService.post('/uploads', data, {
          headers: {
            'Content-Type': 'application/octet-stream',
            Accept: 'application/json',
            'Content-Disposition': `attachment; filename=${dispositionName}`,
            'Content-Range': `bytes ${start}-${start + chunkSize}/${fileSize}`,
          },
        });
        await this.$rHandler(request, (fileResponse) => {
          response = fileResponse;
        });

        this.progress += Math.ceil(100 / chunksCount);
      }
      this.$emit('upload', {
        ...response.data.data,
        original_name: this.original_name,
      });
      this.progress = 0;
    },
  },
};
</script>

<style lang="scss" scoped></style>
